export type PaymentMethodType = "CARD" | "TRANSFER" | "CASH";

export function getPaymentMethodType(): PaymentMethodType[] {
  return ['CARD', 'TRANSFER', 'CASH'];
}

export function paymentMethodTypeToTranslationKey(status: string | undefined): string {
  switch (status) {
    case 'CARD':
      return "payment.methods.card";
    case 'TRANSFER':
      return "payment.methods.transfer";
    case 'CASH':
        return "payment.methods.cash";
    default:
      return "global.unknown";
  }
}
